import { messaging } from '../config/firebase';
import { getToken, onMessage, deleteToken } from 'firebase/messaging';
import { getPersistentDeviceId } from '../Utils/deviceId';
import { request } from '../Utils/request';
import { NOTIFICATION_ICON_URL } from '../constants/notificationIcon';

(window as any).__notificationMsgShown = (window as any).__notificationMsgShown || false;

export const requestFirebaseNotificationPermission = async (
  registration?: ServiceWorkerRegistration,
): Promise<string | null> => {
  if (!messaging) {
    console.warn('[FCM] Messaging is not available in this environment');
    return null;
  }
  
  // Check if Notification API is available
  if (typeof Notification === 'undefined') {
    console.warn('[FCM] Notification API is not available in this environment');
    return null;
  }
  
  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted' && !(window as any).__notificationMsgShown) {
      (window as any).__notificationMsgShown = true;
      window.dispatchEvent(
        new CustomEvent('app-toast', {
          detail: {
            avatar: NOTIFICATION_ICON_URL,
            message: 'Enable notifications from browser settings',
            type: 'warning',
          },
        }),
      );
      return null;
    }

    const currentToken = await getToken(messaging, {
      vapidKey: "BEEgQP4jyAlsEAwVHRqVQGiB5e9DcHssBwFCFjSB0zUIy6j9hMHvircO3Kio1yF7bVQSEpcMh0Sq4qWCNb0P6C8",
      serviceWorkerRegistration: registration,
    });
    console.log("currentToken",currentToken);
    return currentToken;
  } catch (error) {
    console.error('FCM token error', error);
    return null;
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    if (!messaging) {
      console.warn('[FCM] Messaging is not available in this environment');
      return resolve(null);
    }
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });

export const unregisterFcmToken = async (): Promise<void> => {
  if (!messaging) {
    console.warn('[FCM] Messaging is not available in this environment');
    return;
  }

  try {
    const tokenDeleted = await deleteToken(messaging);
    if (tokenDeleted) {
      try {
        const deviceId = getPersistentDeviceId();
        await request<unknown, { deviceId: string }>('/profile/fcm/remove-token', {
          method: 'POST',
          body: { deviceId },
          authorization: true,
        });
        console.info('[FCM] Token unregistered on backend');
      } catch (err) {
        console.error('[FCM] Failed to unregister token on backend', err);
      }
    }
  } catch (err) {
    console.error('[FCM] Failed to delete local token', err);
  }


};

// Initialise FCM after successful login
export const initializeFirebaseMessaging = async (): Promise<string | null> => {
  if (!messaging) {
    console.warn('[FCM] Messaging is not available in this environment');
    return null;
  }
  
  if (!('serviceWorker' in navigator)) {
    console.warn('[FCM] Service workers are not supported in this browser');
    return null;
  }

  try {
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    console.info('[FCM] Service worker registered:', registration.scope);

    const token = await requestFirebaseNotificationPermission(registration);
    if (token) {
      console.log('[FCM] Token acquired:', token);
    }

    // Listen for foreground messages
    onMessageListener().then((payload: any) => {
      console.log('[FCM] Foreground message2:', payload);
      // TODO: Display toast/snackbar if desired
      if (typeof Notification !== 'undefined' && Notification.permission === 'granted') {
        const { title = 'Notification', body = '', icon } = (payload.notification as any) || {};
        new Notification(title, { body, icon: icon || NOTIFICATION_ICON_URL });
        window.dispatchEvent(
          new CustomEvent('app-toast', {
            detail: {
              avatar: NOTIFICATION_ICON_URL,
              title,
              message: body ? `${title}: ${body}` : title,
              type: 'info',
            },
          }),
        );
      } else if (!(window as any).__notificationMsgShown) {
        (window as any).__notificationMsgShown = true;
        window.dispatchEvent(
          new CustomEvent('app-toast', {
            detail: {
              avatar: NOTIFICATION_ICON_URL,
              title: 'Notification',
              message: 'Enable notifications from browser settings',
              type: 'warning',
            },
          }),
        );
      }
      
    });

    return token;
  } catch (err) {
    console.error('[FCM] Initialization error', err);
    return null;
  }
}; 